/* eslint-disable no-prototype-builtins */
export const exportData = (href) => {
  let a = document.createElement("a"); //创建一个<a></a>标签
  a.href = href;
  a.style.display = "none"; // 障眼法藏起来a标签
  document.body.appendChild(a);
  // 将a标签追加到文档对象中
  a.click(); // 模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
  URL.revokeObjectURL(a.href);
  a.remove(); // 一次性的，用完就删除a标签
};

export const objectToUrl = function (obj) {
  var ary = [];
  for (var p in obj)
    if (obj.hasOwnProperty(p) && obj[p]) {
      ary.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
    }
  return ary.join("&");
};

// 使用iframe框架下载文件 -兼容性考虑
export const downloadUrl = (res, name) => {
  let fileName = "";
  let fileType = [".xls", ".zip", ".xlsx", ".pdf"];
  for (let i = 0; i < fileType.length; i++) {
    const element = fileType[i];
    if (name && name.includes(element)) {
      fileName = name;
    }
  }
  fileName = fileName ? fileName : name + ".xlsx";
  console.log("fileName----", fileName);
  const blob = new Blob([res], { type: "application/vnd.ms-excel" });
  // for IE
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    // const fileName = name + ".xlsx";
    window.navigator.msSaveOrOpenBlob(blob, fileName);
  } else {
    // for Non-IE (chrome, firefox etc.)
    // const fileName = name + ".xlsx";
    const elink = document.createElement("a");
    elink.download = fileName;
    elink.style.display = "none";
    elink.href = URL.createObjectURL(blob);
    document.body.appendChild(elink);
    elink.click();
    URL.revokeObjectURL(elink.href);
    document.body.removeChild(elink);
  }
};
